import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Users from './Users';
import { getIsSuperAdmin } from '../../../../auth/selectors';
import { USER_TYPES } from '../../../../auth/constants';

export default compose(
  withRouter,
  connect((state, ownProps) => ({
    isSuperAdmin: getIsSuperAdmin(state),
    addLinkKind: ownProps.location.pathname.match(/^.*admin-users$/)
      ? USER_TYPES.regularAdmin
      : USER_TYPES.shop,
  }))
)(Users);
